"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBadge = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const getVariantColor = (theme, variant) => {
    switch (variant) {
        case 'info':
            return theme.colors.status.ok;
        case 'alert':
            return theme.colors.status.warn;
        case 'error':
            return theme.colors.status.error;
        case 'disabled':
            return theme.colors.gray.s500;
        default:
            return;
    }
};
const getBadgeColor = (theme, variant, isFilled) => {
    const color = getVariantColor(theme, variant);
    if (!color)
        return;
    return (0, styled_components_1.css) `
    border-color: ${color};
    color: ${isFilled ? theme.colors.white.s100 : color};
    ${isFilled && `background-color: ${color}`};
  `;
};
const getSize = (size) => {
    switch (size) {
        case 'small':
            return (0, styled_components_1.css) `
        line-height: 0.875rem;
        padding: 0 ${({ theme }) => theme.space.s050};
      `;
        case 'medium':
        default:
            return (0, styled_components_1.css) `
        padding: 0 ${({ theme }) => theme.space.s100};
      `;
    }
};
exports.StyledBadge = styled_components_1.default.span `
  /* display */
  display: inline-block;

  /* box model */
  border: 1px solid;
  border-radius: ${({ theme }) => theme.radius.s100};
  box-sizing: border-box;

  /* color */
  ${({ theme, variant, isFilled }) => getBadgeColor(theme, variant, isFilled)};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.boldTinyText)};

  /* other */
  cursor: default;

  ${({ size }) => getSize(size)};
`;
